
import template from './modal-field.pug'
import Fields from './_fields.js'

export default Vue.extend({
  template: template(),
  components: {
    Fields,    
  },
  props: {
    formSelected: {
      type: Object,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      data: {
        utmId: null,
        utmCampaign: null,
        utmSource: null,
        utmMedium: null,
        utmContent: null,
        utmTerm: null,
        productId: null,
        facebookCustomFieldConfigs:null
      }
    }
  },
  computed: {
    saveButtonText() {
      return this.$t('general.update')
    }
  },
  mounted() {
    this.data = {
      utmId: this.formSelected.utmId,
      utmCampaign: this.formSelected.utmCampaign,
      utmSource: this.formSelected.utmSource,
      utmMedium: this.formSelected.utmMedium,
      utmContent: this.formSelected.utmContent,
      utmTerm: this.formSelected.utmTerm,
      productId: this.formSelected.productId,
      facebookCustomFieldConfigs:this.formSelected.facebookCustomFieldConfigs
    }
  },
  methods: {
    t(key, options = {}) {
      return this.$t(`customers.facebook.modal-field.${key}`, options)
    },
    cancel() {
      this.$emit('input', false)
    },
    submit() {
      this.$emit('submit', this.data)
    }
  }
})
